<div class="sidebar_container" [class.collapsed]="layoutService.isSidebarCollapsed()" [class.blurred]="isChangePasswordOpen"
  [class.transitioning]="isTransitioning">

  <div class="logo_section">
    <a class="logo" routerLink="/dashboard" aria-label="Go to dashboard">
      <svg width="129" height="66" viewBox="0 0 129 66" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M59.7606 23.0142C59.7606 19.3576 62.7161 16.3369 66.4105 16.3369C70.0521 16.3369 73.0603 19.3046 73.0603 23.0142C73.0603 26.7238 70.0521 29.6915 66.4105 29.6915C62.7161 29.6915 59.7606 26.7238 59.7606 23.0142Z"
          fill="#8DC63F" />
        <path
          d="M68.1521 0.751257C69.102 1.70516 69.102 3.29499 68.1521 4.30189L48.2025 24.2808C47.2525 25.2347 45.6692 25.2347 44.6665 24.2808C43.7165 23.3269 43.7165 21.7371 44.6665 20.7302L64.6688 0.751257C65.6188 -0.250338 67.2021 -0.250338 68.1521 0.751257Z"
          fill="#1C3F94" />
        <path
          d="M64.6688 0.751257C63.7189 1.70516 63.7189 3.29499 64.6688 4.30189L84.6184 24.3338C85.5684 25.2877 87.1517 25.2877 88.1544 24.3338C89.1044 23.3799 89.1044 21.7901 88.1544 20.7832L68.1521 0.751257C67.2021 -0.250338 65.6188 -0.250338 64.6688 0.751257Z"
          fill="#1C3F94" />
        <path class="mb_hide" d="M5.45343 60.1103H4.08124V65.1448H5.45343V60.1103Z" fill="#1C3F94" />
        <path class="mb_hide"
          d="M6.77283 65.1448V60.1103H8.03947L9.72832 62.972V60.1103H10.995V65.1448H9.7811L8.03947 62.0181H7.98669V65.1448H6.77283Z"
          fill="#1C3F94" />
        <path class="mb_hide" d="M12.8949 60.8523H11.5755V60.1103H15.6393V60.8523H14.2671V65.1448H12.8949V60.8523Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M16.2198 65.1448V60.1103H19.9142V60.8523H17.592V62.1771H19.3864V62.9137H17.592V64.4029H20.0725V65.1448H16.2198Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M22.342 62.3838H22.817C23.5558 62.3838 23.8197 62.2248 23.8197 61.5889C23.8197 61.0059 23.5558 60.794 22.817 60.794H22.342V62.3838ZM22.342 65.1448H20.9698V60.1103H22.9225C24.453 60.1103 25.2447 60.5343 25.2447 61.5942C25.2447 62.3891 24.7169 62.7071 24.2947 62.866L25.4558 65.1448H24.0308L23.0281 63.078C22.8697 63.078 22.5531 63.078 22.342 63.078V65.1448Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M26.3002 65.1448V60.1103H27.5668L29.2557 62.972H29.3084V60.1103H30.5223V65.1448H29.3084L27.5668 62.0181V65.1448H26.3002Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M31.6306 65.1448V60.1103H35.3778V60.8523H33.0556V62.1771H34.7972V62.9137H33.0556V64.4029H35.4833V65.1448H31.6306Z"
          fill="#1C3F94" />
        <path class="mb_hide" class="mb_hide"
          d="M37.1722 60.8523H35.8528V60.1103H39.9166V60.8523H38.5444V65.1448H37.1722V60.8523Z" fill="#1C3F94" />
        <path class="mb_hide"
          d="M48.308 60.1103V65.1448H47.0942V61.2232H47.0414L45.8275 65.1448H45.1415L43.8748 61.2232V65.1448H42.6609V60.1103H44.5081L45.4581 63.025H45.5109L46.4609 60.1103H48.308Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M50.5774 63.29H51.6858L51.158 61.1172L50.5774 63.29ZM50.1552 65.1448H48.8358L50.3136 60.1103H52.0024L53.4802 65.1448H52.1607L51.8969 64.0319H50.3663L50.1552 65.1448Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M55.4329 62.3838H55.9079C56.6468 62.3838 56.9107 62.2248 56.9107 61.5889C56.9107 61.0059 56.6468 60.794 55.9079 60.794H55.4329V62.3838ZM55.4329 65.1448H54.0607V60.1103H56.0135C57.544 60.1103 58.3356 60.5343 58.3356 61.5942C58.3356 62.3891 57.8606 62.7071 57.3857 62.866L58.5467 65.1448H57.1218L56.119 63.078C55.9607 63.078 55.644 63.078 55.3801 63.078V65.1448"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M59.3384 65.1448V60.1103H60.7106V61.9651H60.7633L62.1883 60.1103H63.6133L62.0828 61.9651L63.7716 65.1448H62.3466L61.2383 62.8131L60.7106 63.343V65.1448H59.3384Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M64.1411 65.1448V60.1103H67.8354V60.8523H65.5132V62.1771H67.3077V62.9137H65.5132V64.4029H67.9937V65.1448H64.1411Z"
          fill="#1C3F94" />
        <path class="mb_hide" d="M69.6826 60.8523H68.3104V60.1103H72.3742V60.8523H71.0548V65.1448H69.6826V60.8523Z"
          fill="#1C3F94" />
        <path class="mb_hide" d="M74.5381 60.1103H73.1659V65.1448H74.5381V60.1103Z" fill="#1C3F94" />
        <path class="mb_hide"
          d="M75.8575 65.1448V60.1103H77.1241L78.813 62.972H78.8658V60.1103H80.0796V65.1448H78.9185L77.1241 62.0181V65.1448H75.8575Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M83.1407 62.5958H85.4101V65.1395H84.724L84.4601 64.7685C84.0379 65.0865 83.7212 65.1925 83.0879 65.1925C81.9796 65.1925 81.2407 64.7156 81.2407 63.9206V61.3239C81.2407 60.635 81.9268 60.052 83.2462 60.052C84.6184 60.052 85.3045 60.688 85.3045 61.4299V61.7479H83.9851C83.9851 61.0059 83.7212 60.794 83.1935 60.794C82.8768 60.794 82.5601 60.9 82.5601 61.3239V63.9206C82.5601 64.2386 82.7185 64.4506 83.1935 64.4506C83.774 64.4506 83.9323 64.2386 83.9323 63.7617V63.2847H83.1407V62.5958Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M20.442 43.6821V42.3572C20.442 41.2443 20.3892 40.5554 20.2837 40.2904C20.1253 39.9724 19.6504 39.8135 18.9643 39.8135C18.2254 39.8135 17.8032 39.9724 17.6448 40.2904C17.4865 40.6084 17.381 41.2973 17.381 42.4102V43.6821H20.442ZM25.3502 53.751C25.3502 54.7579 24.9808 55.4998 24.1891 55.9768C23.1864 56.5597 21.4448 56.8777 18.9643 56.8777C16.431 56.8777 14.6894 56.5597 13.6866 55.9768C12.8949 55.4998 12.5255 54.7579 12.5255 53.751V42.2512C12.5255 39.9195 14.6894 38.7006 18.9643 38.7006C23.2392 38.7006 25.3502 39.8665 25.3502 42.2512V44.9539H17.381V53.592C17.381 54.5459 17.4865 55.1289 17.6976 55.3938C17.9087 55.6588 18.3309 55.7648 18.9643 55.7648C19.5448 55.7648 19.9142 55.6588 20.1253 55.4468C20.3892 55.1289 20.4948 54.5459 20.4948 53.539V47.1267H25.3502V53.751Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M40.761 53.751C40.761 54.7579 40.3916 55.4998 39.5999 55.9768C38.5972 56.5597 36.8555 56.8777 34.375 56.8777C31.8945 56.8777 30.1001 56.5597 29.1501 55.9768C28.3585 55.4998 27.9363 54.7579 27.9363 53.751V42.2512C27.9363 39.9195 30.1001 38.7006 34.375 38.7006C38.6499 38.7006 40.761 39.8665 40.761 42.1982V44.318H35.8528V42.3042C35.8528 41.1913 35.8 40.5024 35.6944 40.2374C35.5361 39.9194 35.1139 39.7605 34.375 39.7605C33.6362 39.7605 33.2139 39.9194 33.0556 40.2374C32.8973 40.5554 32.7917 41.2443 32.7917 42.3572V53.539C32.7917 54.4929 32.8973 55.0759 33.1084 55.3408C33.3195 55.6058 33.7417 55.7118 34.375 55.7118C34.9556 55.7118 35.325 55.6058 35.5361 55.3938C35.8 55.0759 35.9056 54.4929 35.9056 53.486V47.0737H40.761V53.751Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M56.0134 56.6657H51.158V42.8871C51.158 41.6683 50.9997 40.8733 50.7358 40.5024C50.5247 40.2374 50.1025 40.0784 49.4691 40.0784H48.0442V56.6127H43.1887V35.5739H48.0442V38.8596H49.4691C53.8496 38.8596 56.0134 40.0784 56.0134 42.5162V56.6657Z"
          fill="#1C3F94" />
        <path class="mb_hide" d="M12.9477 37.0577H9.72833V56.6127H4.02846V37.0577H0.809082V35.5686H12.9477V37.0577Z"
          fill="#1C3F94" />
        <path class="mb_hide"
          d="M113.223 54.069C113.223 55.9768 111.059 56.9307 106.785 56.9307C102.51 56.9307 100.399 55.8178 100.399 53.592V49.2465H105.254V53.274C105.254 54.4399 105.36 55.1289 105.571 55.4998C105.782 55.7648 106.151 55.8708 106.785 55.8708C107.365 55.8708 107.787 55.7648 107.998 55.4998C108.21 55.2348 108.315 54.5989 108.315 53.645V48.7695C108.315 48.2396 107.629 47.8156 106.257 47.4447C103.935 46.8087 102.668 46.4378 102.457 46.3848C101.085 45.8018 100.399 45.0069 100.399 44V40.8204C100.399 39.3365 102.51 38.5946 106.785 38.5946C109.265 38.5946 111.007 38.8596 112.009 39.4425C112.801 39.8665 113.223 40.6084 113.223 41.5623V44.53H108.315V41.8802C108.315 40.9263 108.21 40.2904 107.998 40.0254C107.787 39.8135 107.418 39.7075 106.785 39.7075C105.729 39.7075 105.254 40.0784 105.254 40.8204V44.689C105.254 45.1129 105.94 45.4839 107.365 45.8548C109.423 46.3848 110.69 46.7557 111.218 47.0207C112.59 47.6566 113.276 48.5045 113.276 49.5114V54.069"
          fill="#8DC63F" />
        <path class="mb_hide"
          d="M123.884 43.6821V42.3572C123.884 41.2443 123.831 40.5554 123.726 40.2904C123.568 39.9724 123.093 39.8135 122.406 39.8135C121.668 39.8135 121.245 39.9724 121.087 40.2904C120.929 40.6084 120.823 41.2973 120.823 42.4102V43.6821H123.884ZM128.792 53.751C128.792 54.7579 128.423 55.4998 127.631 55.9768C126.629 56.5597 124.887 56.8777 122.406 56.8777C119.873 56.8777 118.132 56.5597 117.129 55.9768C116.337 55.4998 115.968 54.7579 115.968 53.751V42.2512C115.968 39.9195 118.132 38.7006 122.406 38.7006C126.681 38.7006 128.792 39.8665 128.792 42.2512V44.9539H120.77V53.592C120.77 54.5459 120.876 55.1289 121.087 55.3938C121.298 55.6588 121.72 55.7648 122.354 55.7648C122.934 55.7648 123.304 55.6588 123.515 55.4468C123.779 55.1289 123.884 54.5459 123.884 53.539V47.1267H128.74L128.792 53.751Z"
          fill="#8DC63F" />
        <path class="mb_hide"
          d="M92.746 38.8013V53.2687C92.746 54.4346 92.6932 55.0706 92.5877 55.3355C92.4293 55.6535 91.9543 55.8125 91.2683 55.8125C90.6349 55.8125 90.2127 55.7065 90.0016 55.4945C89.7377 55.1765 89.6322 54.4346 89.6322 53.2158V38.8013H84.7767V53.3747C84.7767 55.2295 86.1489 56.3424 88.7878 56.7664V65.1395H93.6432V56.7664C96.282 56.3954 97.6015 55.2825 97.6015 53.4277V38.8013H92.746Z"
          fill="#8DC63F" />
        <path class="mb_hide"
          d="M82.0323 53.0568C82.0323 55.6005 79.6046 56.8724 74.7491 56.8724C72.427 56.8724 71.002 56.3954 70.3687 55.4415C69.6298 56.3954 68.1521 56.8724 65.8827 56.8724C61.0272 56.8724 58.5995 55.6005 58.5995 53.0568V35.5686H64.2994V52.7388C64.2994 52.8448 64.2994 53.0038 64.2466 53.2687C64.1938 53.5337 64.1938 53.7457 64.1938 53.8517C64.1938 54.9646 64.7744 55.4945 65.8827 55.4945C66.7271 55.4945 67.2021 55.1765 67.4132 54.5936C67.466 54.5406 67.466 54.0107 67.466 53.1098V35.5686H73.2186V53.0568C73.2186 53.1628 73.2186 53.3217 73.1658 53.5867C73.1131 53.7987 73.1131 54.0107 73.1131 54.1167C73.1131 55.0706 73.6408 55.4945 74.7491 55.4945C75.8575 55.4945 76.3852 54.9116 76.3852 53.7987C76.3852 53.6397 76.3852 53.4277 76.3324 53.1628V52.6328V35.5686H82.0323V53.0568Z"
          fill="#8DC63F" />
      </svg>
      <!-- @if (showLogoHalloweenBats()) {
      <img
        src="assets/images/events/hallo-pumpkin.gif"
        class="logo-halloween-pumpkin"
        alt=""
        draggable="false"
      />
      } -->
      @if (showLogoRemembrance()) {
      <img
        src="assets/images/events/tim-sol.png"
        class="logo-tim-sol"
        alt=""
        draggable="false"
      />
      }
    </a>
    @if (showLogoRemembrance()) {
    <div class="logo-remembrance-poppy-wrap">
      <img
        src="assets/images/events/rem-poppy.png"
        class="logo-remembrance-poppy"
        alt=""
        draggable="false"
      />
    </div>
    <div class="logo-poppy-fall" aria-hidden="true">
      @for (petal of logoPoppies; track $index) {
      <span
        class="logo-poppy"
        [style.--leaf-left]="petal.left"
        [style.--leaf-size]="petal.size"
        [style.--leaf-duration]="petal.duration"
        [style.--leaf-delay]="petal.delay"
        [style.--leaf-drift]="petal.drift"
        [style.--leaf-spin]="petal.spin"
        [style.background-image]="'url(' + petal.src + ')'"
      ></span>
      }
    </div>
    }
    @if (showLogoMapleFall()) {
    <div class="logo-maple-fall" aria-hidden="true">
      @for (leaf of logoMapleLeaves; track $index) {
      <span
        class="logo-maple"
        [style.--leaf-left]="leaf.left"
        [style.--leaf-size]="leaf.size"
        [style.--leaf-duration]="leaf.duration"
        [style.--leaf-delay]="leaf.delay"
        [style.--leaf-drift]="leaf.drift"
        [style.--leaf-spin]="leaf.spin"
        [style.background-image]="'url(' + leaf.src + ')'"
      ></span>
      }
    </div>
    }
    @if (showLogoHalloweenBats()) {
    <div class="logo-halloween-decor" aria-hidden="true">
      <img src="assets/images/events/hallo-pbat.gif" class="logo-halloween-bat bat-1" alt="" draggable="false" />
      <!-- <img src="assets/images/events/hallo-pbat.gif" class="logo-halloween-bat bat-2" alt="" draggable="false" /> -->
      <img src="assets/images/events/hallo-pbat.gif" class="logo-halloween-bat bat-3" alt="" draggable="false" />
     <div class="logo-halloween-spider-wrap">
        <img
          src="assets/images/events/hallo-spi.gif"
          class="logo-halloween-spider"
          alt=""
          draggable="false"
        />
      </div>
    </div>
    }
  </div>
  <!-- Santa peek decoration -->
  <!-- <app-sidebar-festival-decoration [showTree]="false" [showSanta]="true"></app-sidebar-festival-decoration> -->
  <!-- Collapse Button Banner (inside sidebar) -->

  <div class="side_bar_wrap" (scroll)="onViewportChange()">
    @if (layoutService.showSidebar()) {
    <button
      type="button"
      class="sidebar_collapse_btn_banner"
      [class.collapsed]="layoutService.isSidebarCollapsed()"
      [attr.aria-label]="layoutService.isSidebarCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      [attr.title]="layoutService.isSidebarCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      (click)="toggleSidebar()"
    >
      <span class="hamburger" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>
    }
    <div class="user_info_shell">
    <div
      #userInfoSection
      class="user_info"
      [ngStyle]="getUserInfoBgStyle()"
      [style.--user-info-custom-text]="hasCustomUserInfoText && !isThemeActive() ? userInfoTextColor : null"
      [style.--user-info-custom-bg]="
        !isThemeActive()
          ? hasCustomUserInfoBg
            ? userInfoBgColor
            : preferSolidDefaultBg
              ? '#25335b'
              : null
          : null
      "
      [style.--user-info-custom-banner]="hasCustomUserInfoBanner && !isThemeActive() ? 'url(' + userInfoBannerImage + ')' : null"
      [class.user_info--custom-text]="hasCustomUserInfoText && !isThemeActive()"
      [class.user_info--custom-bg]="(hasCustomUserInfoBg || preferSolidDefaultBg) && !isThemeActive()"
      [class.user_info--custom-banner]="hasCustomUserInfoBanner && !isThemeActive()"
      [class.user_info--has-banner]="hasUserInfoBannerImage()"
      [class.text_overlay]="hasUserInfoBannerImage()"
      [class.time_period_morning]="currentTimePeriod === 'morning'"
      [class.time_period_afternoon]="currentTimePeriod === 'afternoon'"
      [class.time_period_evening]="currentTimePeriod === 'evening'"
      [class.time_period_night]="currentTimePeriod === 'night'"
    >
      @if (!isThemeActive()) {
        <div class="user_info_customize_stack" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="user_info_customize_btn"
            [class.user_info_customize_btn--open]="isUserInfoPickerOpen"
            [attr.aria-expanded]="isUserInfoPickerOpen"
            [attr.aria-label]="isUserInfoPickerOpen ? 'Close banner customization' : 'Customize User banner'"
            matTooltip="Customize User Banner"
            [matTooltipDisabled]="isUserInfoPickerOpen"
            matTooltipPosition="right"
            (click)="toggleUserInfoPicker($event)"
          >
            @if (isUserInfoPickerOpen) {
              <i class="fas fa-times" aria-hidden="true"></i>
            } @else {
              <i class="fas fa-palette" aria-hidden="true"></i>
            }
          </button>
        </div>
      }
      @if (hasUserInfoBannerImage()) {
      <div
        class="text_overlay_bg"
      ></div>
      }

      <div class="user_info_greeting">
        <h2 class="username_txt">Hi
          <span
            class="username_txt__name"
            [matTooltip]="userName || ''"
            [matTooltipTruncateWhen]="!!userName"
            matTooltipPosition="right">{{ userName }}</span>,
        </h2>
        <p class="greeting">{{ greeting }}</p>
      </div>

      <div class="status_list">
        @for (item of statusItems; track item.label) {
        <div class="status_item" (click)="onStatusItemClick(item)">
          <span>{{item.label}}</span>
          <span class="count">{{item.count}}</span>
        </div>
        }
      </div>

      <button class="quick_add radial_menu_btn" (click)="onAddClick()" [class.not_active]="isRadialMenuOpen">
        <img src="assets/images/quick.svg" alt="Add">
        <div class="quick_add_text">
          GET STARTED
        </div>
      </button>
    </div>
    </div>

    <!-- Sidebar -->
    @if (shouldShowSidebar()) {
    <div class="sidebar">
      <nav class="sidebar_nav">
        <!-- Current Page Submenu - Shows only submenu items -->
        @if (getCurrentPageSubmenu()?.subs?.length) {
        <div class="nav_section">
          <div class="section_header">
            <h3>{{getCurrentPageSubmenu()?.label}}</h3>
            <div class="section_dropdown_container">
              <a class="menu_dots" (click)="toggleSectionDropdown('current-page', $event)">
                <i class="fas fa-ellipsis-v"></i>
              </a>
              @if (openSectionDropdown === 'current-page') {
              <div class="section_dropdown"
                (click)="$event.stopPropagation()" [class.dropdown-open]="openSectionDropdown === 'current-page'">
                <div class="dropdown-item" (click)="onSectionDropdownClick('edit', 'current-page')">
                  <i class="wl_icon_edit"></i>
                  <span>Edit</span>
                </div>
                <div class="dropdown-item" (click)="onSectionDropdownClick('settings', 'current-page')">
                  <i class="wl_icon_gear"></i>
                  <span>Settings</span>
                </div>
                <div class="dropdown-item" (click)="onSectionDropdownClick('hide', 'current-page')">
                  <i class="fa-regular fa-eye-slash"></i>
                  <span>Hide</span>
                </div>
              </div>
              }
            </div>
          </div>

          <!-- Only Submenu Items -->
          <ul class="nav_list">
            @for (subItem of getCurrentPageSubmenu()?.subs; track subItem.label) {
            <li class="nav_item"
              [class.active]="isSubItemActive(subItem)">
              <a [matTooltip]="subItem.label" matTooltipPosition="right" matTooltipAlways
                [matTooltipDisabled]="!layoutService.isSidebarCollapsed()" [href]="getSubItemHref(subItem)"
                (click)="onSubItemClick(subItem, $event)" (contextmenu)="onSubItemContextMenu($event)">
                <!-- <img [src]="getSubmenuIcon(subItem)" [alt]="subItem.label"> -->
                <i [ngClass]="getSubmenuIcon(subItem)"></i>
                <span>{{subItem.label}}</span>
                @if (getSubmenuCount(subItem) > 0 && subItem.label !== 'Hours') {
                <span class="count">{{getSubmenuCount(subItem)}}</span>
                }
                <!-- Show hours in brackets for Hours item -->
                @if (subItem.label === 'Hours' && getSubmenuHours(subItem)) {
                <span class="hours">
                  {{getSubmenuHours(subItem)}}
                </span>
                }
              </a>
            </li>
            }
          </ul>
        </div>
        }

        <!-- <div class="nav_section my_work_hub" *ngIf="isDashboard">
          <div class="section_header">
            <h3>My Work Hub</h3>
            <div class="section_dropdown_container">
              <a class="menu_dots" (click)="toggleSectionDropdown('work-hub', $event)">
                <i class="fas fa-ellipsis-v"></i>
              </a>
              <div class="section_dropdown" *ngIf="openSectionDropdown === 'work-hub'"
                (click)="$event.stopPropagation()" [class.dropdown-open]="openSectionDropdown === 'work-hub'">
                <div class="dropdown-item" (click)="onSectionDropdownClick('edit', 'work-hub')">
                  <i class="wl_icon_edit"></i>
                  <span>Edit</span>
                </div>
                <div class="dropdown-item" (click)="onSectionDropdownClick('settings', 'work-hub')">
                  <i class="wl_icon_gear"></i>
                  <span>Settings</span>
                </div>
                <div class="dropdown-item" (click)="onSectionDropdownClick('hide', 'work-hub')">
                  <i class="fa-regular fa-eye-slash"></i>
                  <span>Hide</span>
                </div>
              </div>
            </div>
          </div>
          <ul class="nav_list">
            <li>
              <a matTooltip="My Team" matTooltipPosition="right"
                [matTooltipDisabled]="!layoutService.isSidebarCollapsed()" routerLink="/my-team"
                routerLinkActive="active">
                <i class="wl_icon_staffing"></i>
                <span>My Team</span>
              </a>
            </li>
            <li>
              <a matTooltip="Daily Assignments" matTooltipPosition="right"
                [matTooltipDisabled]="!layoutService.isSidebarCollapsed()" routerLink="/daily-assignments"
                routerLinkActive="active">
                <i class="wl_icon_document"></i>
                <span>Daily Assignments</span>
              </a>
            </li>

          </ul>
        </div> -->

        <!-- <div class="nav_section my_widgets" >
          <div class="section_header">
            <h3>My Shortcuts</h3>
            <div class="section_dropdown_container">
              <a class="menu_dots" (click)="toggleSectionDropdown('shortcuts', $event)">
                <i class="fas fa-ellipsis-v"></i>
              </a>
              <div class="section_dropdown" 
                   *ngIf="openSectionDropdown === 'shortcuts'" 
                   (click)="$event.stopPropagation()"
                   [class.dropdown-open]="openSectionDropdown === 'shortcuts'">
                <div class="dropdown-item" (click)="onSectionDropdownClick('edit', 'shortcuts')">
                  <i class="wl_icon_edit"></i>
                  <span>Edit</span>
                </div>
                  <div class="dropdown-item" (click)="onSectionDropdownClick('settings', 'shortcuts')">
                    <i class="wl_icon_gear"></i>
                  <span>Settings</span>
                </div>
                <div class="dropdown-item" (click)="onSectionDropdownClick('hide', 'shortcuts')">
                 <i class="fa-regular fa-eye-slash"></i>
                  <span>Hide</span>
                </div>
              </div>
            </div>
          </div>
          <div class="widgets_grid">
            <div class="widget_item" 
                 *ngFor="let widget of widgets; let i = index" 
                 [routerLink]="widget.link" 
                 [class.warning]="widget.type === 'warning'" 
                 [class.danger]="widget.type === 'danger'"
                 [matTooltip]="widget.label"
                 matTooltipPosition="right"
                 [matTooltipDisabled]="!layoutService.isSidebarCollapsed()">
                <div class="widget_dropdown_container">
                  <a class="item_menu_dots" (click)="toggleWidgetDropdown(i, $event)">
                    <i class="fas fa-ellipsis-v"></i>
                  </a>
                  <div class="widget_dropdown" 
                       *ngIf="openWidgetDropdown === i" 
                       (click)="$event.stopPropagation()"
                       [class.dropdown-open]="openWidgetDropdown === i">
                    <div class="dropdown-item" (click)="onWidgetDropdownClick('edit', widget, i)">
                      <i class="wl_icon_edit"></i>
                      <span>Edit</span>
                    </div>
                    <div class="dropdown-item" (click)="onWidgetDropdownClick('settings', widget, i)">
                      <i class="wl_icon_gear"></i>
                      <span>Settings</span>
                    </div>
                    <div class="dropdown-item" (click)="onWidgetDropdownClick('remove', widget, i)">
                      <i class="wl_icon_delete"></i>
                      <span>Remove</span>
                    </div>
                  </div>
                </div>
              <div class="widget_icon">
                <div>
                    <i class="{{widget.iconClass}}" [title]="widget.label"></i>
                </div>
                <span class="widget_count" *ngIf="widget.count">{{widget.count}}</span>
              </div>
              <div class="widget_label">{{widget.label}}</div>
            </div>
          </div>
        </div> -->

        <!-- Time Summary Section - Shows when on task or revision detail page -->
        @if (showTimeSummary()) {
        <div class="nav_section time_summary_section">
          <div class="section_header">
           <h3>{{ getItemTypeDisplayName() }} Hours & Status</h3>
          </div>
          @if (!isTimeSummaryLoading() && taskHourStatus()) {
          <div class="time_summary_content">
            <div class="status-container">
              <div class="chart-section">
                <!-- Task Status Chart -->
                <div class="donut-container task_stat_donut">
                  <div class="gauge-wrapper">
                    <div #taskStatusChartContainer class="gauge-chart"></div>
                    <!-- Loading spinner overlay -->
                    @if (isChartsLoading()) {
                    <div class="spinner-only">
                      <app-spinner [size]="30"></app-spinner>
                    </div>
                    }
                  </div>
                   <div class="caption">{{ getItemTypeDisplayName() }} Status</div>
                </div>

                <!-- Balance Hours Chart -->
                <div class="donut-container balance_hrs_donut">
                  <div class="gauge-wrapper">
                    <div #balanceHoursChartContainer class="gauge-chart"></div>
                    <!-- Loading spinner overlay -->
                    @if (isChartsLoading()) {
                    <div class="spinner-only">
                      <app-spinner [size]="30"></app-spinner>
                    </div>
                    }
                  </div>
                </div>
              </div>

              <div class="info-section">
                <ul class="stats">
                  <li class="light">
                    <span>Planned Hrs :</span>
                    <b>{{ formatHours(taskHourStatus()?.totalPlannedHours) }}</b>
                  </li>
                  <li class="green">
                    <span>Hours Filled :</span>
                    <b>{{ formatHours(taskHourStatus()?.hourFilledData) }}</b>
                  </li>
                  <li class="blue">
                    <span>Unfilled Hours :</span>
                    <b>{{ formatHours(taskHourStatus()?.unfilledHours) }}</b>
                  </li>
                  <li class="pink">
                    <span>Offset Hours :</span>
                    <b>{{ formatHours(taskHourStatus()?.offsetHours) }}</b>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          }
        </div>
        }
      </nav>
    </div>
    }
    <!-- End Sidebar -->

  </div>
  <!-- Footer Logo -->
  <div class="sidebar_footer">
    <app-sidebar-festival-decoration [showTree]="false"></app-sidebar-festival-decoration>
    <svg class="wrkldge" width="121" height="34" viewBox="0 0 121 34" fill="none" class="mb_hide"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M47.3217 18.699C47.3217 19.9403 47.0473 21.0379 46.4985 21.9787C45.9497 22.9195 45.2049 23.6643 44.2771 24.187C43.3494 24.7227 42.3041 24.9841 41.1542 24.9841C40.0044 24.9841 38.959 24.7227 38.0313 24.187C37.1036 23.6513 36.3588 22.9195 35.81 21.9787C35.2612 21.0379 34.9868 19.9403 34.9868 18.699C34.9868 17.4577 35.2612 16.3601 35.81 15.4193C36.3588 14.4785 37.1036 13.7337 38.0313 13.198C38.959 12.6622 40.0044 12.3878 41.1542 12.3878C42.3041 12.3878 43.3494 12.6622 44.2771 13.198C45.2049 13.7337 45.9497 14.4785 46.4985 15.4193C47.0473 16.3601 47.3217 17.4577 47.3217 18.699ZM44.6038 18.699C44.6038 17.9281 44.447 17.2617 44.1334 16.6867C43.8198 16.1249 43.4017 15.6806 42.879 15.3539C42.3564 15.0403 41.7814 14.8705 41.1411 14.8705C40.5009 14.8705 39.926 15.0273 39.4033 15.3539C38.8806 15.6675 38.4625 16.1118 38.1489 16.6867C37.8353 17.2486 37.6785 17.9281 37.6785 18.699C37.6785 19.4569 37.8353 20.1233 38.1489 20.6851C38.4625 21.247 38.8806 21.6913 39.4033 22.0179C39.926 22.3446 40.5009 22.5014 41.1411 22.5014C41.7814 22.5014 42.3564 22.3446 42.879 22.0179C43.4017 21.7043 43.8198 21.2601 44.1334 20.6851C44.447 20.1102 44.6038 19.4569 44.6038 18.699Z" />
      <path
        d="M49.8697 24.7619C49.4777 24.7619 49.151 24.6313 48.8897 24.3699C48.6283 24.1086 48.4977 23.7819 48.4977 23.3769V13.995C48.4977 13.603 48.6283 13.2764 48.8897 13.002C49.151 12.7406 49.4777 12.61 49.8697 12.61C50.2617 12.61 50.5883 12.7406 50.8497 13.002C51.111 13.2633 51.2417 13.59 51.2417 13.995V16.1249L51.0849 14.6091C51.2547 14.2433 51.4638 13.9297 51.7382 13.6422C51.9995 13.3678 52.3001 13.1326 52.6398 12.9366C52.9665 12.7537 53.3323 12.61 53.7113 12.5185C54.0902 12.427 54.4691 12.3878 54.8481 12.3878C55.3054 12.3878 55.6843 12.5185 55.9979 12.7798C56.3115 13.0412 56.4683 13.3417 56.4683 13.6945C56.4683 14.191 56.3377 14.5569 56.0763 14.779C55.815 15.0011 55.5406 15.1057 55.2401 15.1057C54.9526 15.1057 54.6913 15.0534 54.4561 14.9489C54.2209 14.8443 53.9465 14.7921 53.6459 14.7921C53.3715 14.7921 53.0971 14.8574 52.8227 14.9881C52.5483 15.1187 52.287 15.3147 52.0518 15.5891C51.8166 15.8635 51.6337 16.2033 51.4899 16.5953C51.3462 17.0003 51.2678 17.4707 51.2678 18.0195V23.403C51.2678 23.795 51.1371 24.1217 50.8758 24.3961C50.5883 24.6313 50.2617 24.7619 49.8697 24.7619Z" />
      <path
        d="M58.8595 24.762C58.4675 24.762 58.1409 24.6313 57.8795 24.37C57.6182 24.1086 57.4875 23.782 57.4875 23.3769V10.65C57.4875 10.258 57.6182 9.93129 57.8795 9.65689C58.1409 9.39556 58.4675 9.26489 58.8595 9.26489C59.2515 9.26489 59.5782 9.39556 59.8395 9.65689C60.1009 9.91823 60.2315 10.2449 60.2315 10.65V23.3769C60.2315 23.7689 60.1009 24.0956 59.8395 24.37C59.5782 24.6313 59.2515 24.762 58.8595 24.762ZM66.0854 12.61C66.4382 12.61 66.7387 12.7537 67.0001 13.0412C67.2614 13.3286 67.3921 13.603 67.3921 13.8774C67.3921 14.2433 67.2091 14.583 66.8433 14.8966L60.0094 21.1817L59.8918 18.0457L65.0793 13.0412C65.3667 12.7537 65.7065 12.61 66.0854 12.61ZM66.4251 24.7358C66.0331 24.7358 65.6934 24.579 65.4321 24.2785L61.2246 19.8228L63.2891 17.915L67.379 22.3708C67.6665 22.6713 67.8102 23.011 67.8102 23.39C67.8102 23.782 67.6534 24.1086 67.3398 24.3569C67.0393 24.6182 66.7257 24.7358 66.4251 24.7358Z" />
      <path
        d="M78.0937 22.1094C78.4857 22.1094 78.8123 22.2401 79.0867 22.4884C79.3481 22.7366 79.4787 23.0633 79.4787 23.4553C79.4787 23.8342 79.3481 24.1478 79.0867 24.3961C78.8254 24.6444 78.4987 24.775 78.0937 24.775H70.711C70.319 24.775 69.9923 24.6444 69.7179 24.383C69.4566 24.1217 69.3259 23.795 69.3259 23.39V11.5516C69.3259 11.1596 69.4566 10.8329 69.731 10.5585C70.0054 10.2972 70.3582 10.1665 70.7763 10.1665C71.1422 10.1665 71.4558 10.2972 71.7433 10.5585C72.0177 10.8198 72.1614 11.1465 72.1614 11.5516V22.4884L71.6649 22.0964H78.0937V22.1094Z" />
      <path
        d="M89.135 12.6099C89.527 12.6099 89.8537 12.7405 90.115 13.0019C90.3763 13.2632 90.507 13.5899 90.507 13.9949V19.7704C90.507 21.3776 90.0627 22.6451 89.1611 23.5859C88.2726 24.5267 86.979 24.9971 85.3065 24.9971C83.634 24.9971 82.3404 24.5267 81.4518 23.5859C80.5633 22.6451 80.119 21.3776 80.119 19.7704V13.9949C80.119 13.6029 80.2497 13.2763 80.511 13.0019C80.7724 12.7405 81.099 12.6099 81.491 12.6099C81.883 12.6099 82.2097 12.7405 82.471 13.0019C82.7324 13.2632 82.863 13.5899 82.863 13.9949V19.7704C82.863 20.6981 83.0721 21.3776 83.4772 21.8219C83.8822 22.2661 84.4964 22.4883 85.3196 22.4883C86.1558 22.4883 86.77 22.2661 87.1881 21.8219C87.5932 21.3776 87.8022 20.6851 87.8022 19.7704V13.9949C87.8022 13.6029 87.9329 13.2763 88.1942 13.0019C88.4164 12.7405 88.743 12.6099 89.135 12.6099Z" />
      <path
        d="M97.0664 12.3878C97.7067 12.3878 98.2816 12.4924 98.8174 12.6884C99.3531 12.8844 99.8104 13.1326 100.189 13.4332C100.581 13.7337 100.882 14.0473 101.104 14.3478C101.326 14.6614 101.431 14.9227 101.431 15.1318L100.843 15.4323V13.7729C100.843 13.3809 100.973 13.0542 101.235 12.7798C101.496 12.5185 101.823 12.3878 102.215 12.3878C102.607 12.3878 102.933 12.5185 103.195 12.7798C103.456 13.0412 103.587 13.3678 103.587 13.7729V23.8734C103.587 25.1931 103.299 26.2515 102.737 27.0355C102.176 27.8326 101.418 28.4075 100.503 28.7603C99.5752 29.1131 98.5822 29.2961 97.5238 29.2961C97.2232 29.2961 96.8312 29.2569 96.3478 29.1785C95.8643 29.1001 95.407 29.0086 94.9627 28.9041C94.5184 28.7995 94.1918 28.695 93.9696 28.6035C93.5123 28.4075 93.1987 28.1593 93.0288 27.8718C92.859 27.5713 92.8198 27.2577 92.9243 26.931C93.055 26.4867 93.2771 26.1993 93.5776 26.0294C93.8782 25.8726 94.2048 25.8465 94.5315 25.9771C94.6883 26.0163 94.9366 26.1078 95.2763 26.2515C95.6291 26.3822 96.008 26.5129 96.4262 26.6305C96.8443 26.7481 97.2102 26.8003 97.5238 26.8003C98.6606 26.8003 99.4968 26.5782 100.046 26.1209C100.594 25.6635 100.869 25.0363 100.869 24.2393V22.2662L101.143 22.4753C101.143 22.6713 101.039 22.9065 100.843 23.1939C100.634 23.4683 100.359 23.7558 100.006 24.0171C99.6536 24.2915 99.2355 24.5267 98.752 24.7097C98.2686 24.8926 97.759 24.9971 97.2102 24.9971C96.1387 24.9971 95.1718 24.7227 94.3094 24.187C93.447 23.6513 92.7675 22.9065 92.271 21.9657C91.7744 21.0249 91.5262 19.9273 91.5262 18.7121C91.5262 17.4707 91.7744 16.3731 92.271 15.4323C92.7675 14.4916 93.447 13.7468 94.2963 13.211C95.0803 12.6492 96.0211 12.3878 97.0664 12.3878ZM97.4976 14.8836C96.8182 14.8836 96.2171 15.0534 95.7075 15.3801C95.1979 15.7067 94.7928 16.1641 94.5054 16.739C94.2179 17.3139 94.0742 17.9673 94.0742 18.6859C94.0742 19.3915 94.2179 20.0449 94.5054 20.6198C94.7928 21.1947 95.1979 21.6521 95.7075 21.9787C96.2171 22.3185 96.8182 22.4753 97.4976 22.4753C98.1902 22.4753 98.8043 22.3054 99.3139 21.9787C99.8235 21.6521 100.229 21.1947 100.516 20.6198C100.804 20.0449 100.947 19.4046 100.947 18.6859C100.947 17.9542 100.804 17.3139 100.516 16.739C100.229 16.1641 99.8235 15.7067 99.3139 15.3801C98.8043 15.0534 98.1902 14.8836 97.4976 14.8836Z" />
      <path
        d="M110.577 24.9841C109.284 24.9841 108.173 24.7097 107.232 24.174C106.292 23.6382 105.56 22.9065 105.05 21.9788C104.541 21.051 104.292 20.0057 104.292 18.8428C104.292 17.4838 104.567 16.3209 105.116 15.354C105.664 14.387 106.396 13.6553 107.285 13.1457C108.173 12.6361 109.127 12.3748 110.12 12.3748C110.891 12.3748 111.623 12.5316 112.315 12.8452C113.008 13.1588 113.609 13.603 114.145 14.1518C114.68 14.7006 115.098 15.3409 115.399 16.0726C115.713 16.8044 115.869 17.5753 115.869 18.3854C115.856 18.7513 115.713 19.0388 115.438 19.274C115.164 19.5092 114.85 19.6137 114.484 19.6137H105.808L105.129 17.3401H113.465L112.969 17.7974V17.1833C112.942 16.739 112.786 16.347 112.498 16.0073C112.224 15.6545 111.871 15.3801 111.453 15.1841C111.035 14.975 110.59 14.8836 110.12 14.8836C109.663 14.8836 109.245 14.9489 108.853 15.0665C108.461 15.1841 108.121 15.3932 107.833 15.6806C107.546 15.9681 107.324 16.3601 107.154 16.8436C106.984 17.327 106.906 17.9412 106.906 18.686C106.906 19.5092 107.076 20.2017 107.415 20.7636C107.755 21.3254 108.199 21.7566 108.735 22.0572C109.271 22.3577 109.846 22.5014 110.447 22.5014C111.009 22.5014 111.453 22.4622 111.793 22.3708C112.119 22.2793 112.394 22.1748 112.603 22.0441C112.812 21.9134 112.995 21.8089 113.165 21.7174C113.439 21.5868 113.7 21.5084 113.936 21.5084C114.262 21.5084 114.55 21.626 114.759 21.8481C114.981 22.0702 115.085 22.3446 115.085 22.6452C115.085 23.0502 114.876 23.4292 114.445 23.7558C114.053 24.0956 113.504 24.383 112.786 24.6313C112.067 24.8665 111.335 24.9841 110.577 24.9841Z" />
      <path
        d="M37.3649 6.48168L36.8422 6.18115C36.0452 5.72381 35.0129 5.99821 34.5556 6.79528L32.5694 10.2318C32.5172 10.3102 32.478 10.4017 32.4257 10.4801L31.3412 12.3486C30.9753 12.9758 30.6225 13.5899 30.2566 14.2171C29.7601 15.0665 29.2767 15.9158 28.7932 16.7651C28.3228 17.5753 27.8524 18.3985 27.382 19.2086C27.1337 19.6398 26.8985 20.071 26.5065 20.3977C25.6964 21.0641 24.2983 20.9334 23.6972 20.071C23.2791 19.4699 22.9263 18.8297 22.5604 18.2025C22.0639 17.3531 21.5804 16.4907 21.0839 15.6414C20.6265 14.8443 20.1561 14.0473 19.6988 13.2502C19.346 12.6361 19.0063 12.0089 18.6535 11.3947C18.1831 10.5846 17.7127 9.77448 17.2423 8.96434C16.7719 8.16728 16.3407 7.35715 15.818 6.59928C15.1385 5.61928 14.1847 4.97901 13.0609 4.60008C12.3161 4.35181 11.5583 4.27341 10.7743 4.33875C9.51986 4.44328 8.42226 4.91368 7.48146 5.74995C6.91959 6.24648 6.47533 6.83448 6.14866 7.50088C5.86119 8.07581 5.67826 8.67688 5.59986 9.30408C5.45613 10.3494 5.59986 11.3425 6.03106 12.2963C6.22706 12.7275 6.47533 13.1457 6.69746 13.5507C7.03719 14.1518 7.37693 14.7398 7.71666 15.3278C8.00413 15.8374 8.30466 16.3339 8.60519 16.8435C9.01026 17.5491 9.41532 18.2678 9.82039 18.9865C10.3169 19.8619 10.8396 20.7113 11.3361 21.5867C11.8196 22.4361 12.4207 23.1547 13.2308 23.6905C14.0279 24.2262 14.8903 24.5659 15.8441 24.6835C16.6673 24.7881 17.4905 24.7358 18.2876 24.5137C19.2415 24.2523 20.0647 23.7819 20.7572 23.0763C20.8748 22.9587 20.9663 22.9587 21.0969 23.0763C21.306 23.2723 21.5151 23.4553 21.7372 23.6251C22.4036 24.1347 23.1615 24.4614 23.9716 24.6313C24.9647 24.8403 25.9708 24.8142 26.9508 24.5267C28.4534 24.0825 29.6033 23.1939 30.4265 21.8611C30.7271 21.3646 31.0014 20.8681 31.2889 20.3585C31.7462 19.5745 32.2166 18.7905 32.6609 18.0065C33.1444 17.1702 33.6148 16.3209 34.0982 15.4846C34.5948 14.6353 35.0913 13.7859 35.5748 12.9235C35.6532 12.7929 35.7316 12.6622 35.7969 12.5185L37.979 8.76835C38.4364 7.95821 38.162 6.93901 37.3649 6.48168ZM18.5359 19.6006C18.4444 19.7051 18.3921 19.8227 18.3137 19.9273C17.3729 21.1425 15.6089 21.051 14.838 19.7443C14.3153 18.8558 13.8057 17.9673 13.2961 17.0787C12.5905 15.8635 11.898 14.6483 11.1924 13.4331C10.7089 12.5969 10.2255 11.7737 9.74199 10.9505C9.58519 10.6761 9.48066 10.3755 9.50679 10.1011C9.54599 8.75528 10.9441 7.85368 12.1593 8.57235C12.5383 8.79448 12.7604 9.16035 12.9695 9.52621C13.5967 10.6107 14.2239 11.6822 14.838 12.7667C15.4391 13.8121 16.0401 14.8705 16.6412 15.9158C17.1769 16.8435 17.7257 17.7843 18.2615 18.7121C18.366 18.895 18.4705 19.0649 18.5751 19.2478C18.6665 19.3654 18.6404 19.483 18.5359 19.6006Z" />
      <path
        d="M29.8777 7.80143C25.3175 6.9129 24.1676 9.74836 24.1284 9.83983C23.8148 10.3886 23.4881 10.9374 23.1615 11.4993C22.7172 12.2572 22.286 13.015 21.8417 13.786C21.7503 13.9428 21.6719 14.0996 21.5673 14.2694C21.6457 14.4001 21.7111 14.5177 21.7895 14.6353C22.1031 15.171 22.4036 15.6937 22.7172 16.2294C23.0569 16.8174 23.3967 17.4185 23.7233 18.0065C23.8017 18.1372 23.8932 18.1502 23.9847 18.0196C24.05 17.9281 24.0761 17.8236 24.1284 17.7321C24.4812 17.118 24.8471 16.5038 25.1999 15.8897C25.6964 15.0404 26.1799 14.178 26.6764 13.3286C26.9247 12.8974 27.1729 12.4662 27.4212 12.0481L29.8777 7.80143Z"
        fill="#90C544" />
    </svg>


    <svg width="34" height="22" viewBox="0 0 34 22" fill="none" class="mb_show" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.2413 3.09752L31.7187 2.79699C30.9216 2.33966 29.8893 2.61406 29.432 3.41112L27.4459 6.84766C27.3936 6.92606 27.3544 7.01752 27.3021 7.09592L26.2176 8.96445C25.8517 9.59165 25.4989 10.2058 25.1331 10.833C24.6365 11.6823 24.1531 12.5317 23.6696 13.381C23.1992 14.1911 22.7288 15.0143 22.2584 15.8245C22.0101 16.2557 21.7749 16.6869 21.3829 17.0135C20.5728 17.6799 19.1747 17.5492 18.5736 16.6869C18.1555 16.0858 17.8027 15.4455 17.4368 14.8183C16.9403 13.969 16.4568 13.1066 15.9603 12.2573C15.5029 11.4602 15.0325 10.6631 14.5752 9.86605C14.2224 9.25192 13.8827 8.62472 13.5299 8.01059C13.0595 7.20046 12.5891 6.39032 12.1187 5.58019C11.6483 4.78312 11.2171 3.97299 10.6944 3.21512C10.0149 2.23513 9.06106 1.59486 7.93733 1.21593C7.19253 0.967659 6.43466 0.889259 5.65066 0.954592C4.39626 1.05913 3.29866 1.52953 2.35786 2.36579C1.796 2.86232 1.35173 3.45032 1.02506 4.11672C0.737597 4.69166 0.554663 5.29272 0.476263 5.91992C0.33253 6.96526 0.476263 7.95832 0.907463 8.91219C1.10346 9.34339 1.35173 9.76152 1.57386 10.1666C1.9136 10.7677 2.25333 11.3557 2.59306 11.9437C2.88053 12.4533 3.18106 12.9498 3.4816 13.4594C3.88666 14.165 4.29173 14.8837 4.69679 15.6023C5.19333 16.4778 5.71599 17.3271 6.21253 18.2026C6.69599 19.0519 7.29706 19.7706 8.10719 20.3063C8.90426 20.842 9.76666 21.1818 10.7205 21.2994C11.5437 21.4039 12.3669 21.3516 13.164 21.1295C14.1179 20.8682 14.9411 20.3978 15.6336 19.6922C15.7512 19.5746 15.8427 19.5746 15.9733 19.6922C16.1824 19.8882 16.3915 20.0711 16.6136 20.241C17.28 20.7506 18.0379 21.0772 18.848 21.2471C19.8411 21.4562 20.8472 21.43 21.8272 21.1426C23.3299 20.6983 24.4797 19.8098 25.3029 18.477C25.6035 17.9804 25.8779 17.4839 26.1653 16.9743C26.6227 16.1903 27.0931 15.4063 27.5373 14.6223C28.0208 13.7861 28.4912 12.9367 28.9747 12.1005C29.4712 11.2511 29.9677 10.4018 30.4512 9.53939C30.5296 9.40872 30.608 9.27805 30.6733 9.13432L32.8554 5.38419C33.3128 4.57406 33.0384 3.55486 32.2413 3.09752ZM13.4123 16.2164C13.3208 16.321 13.2685 16.4386 13.1901 16.5431C12.2493 17.7583 10.4853 17.6669 9.71439 16.3602C9.19173 15.4717 8.68213 14.5831 8.17253 13.6946C7.46693 12.4794 6.77439 11.2642 6.06879 10.049C5.58533 9.21272 5.10186 8.38952 4.61839 7.56632C4.4616 7.29192 4.35706 6.99139 4.38319 6.71699C4.42239 5.37112 5.82053 4.46952 7.03573 5.18819C7.41466 5.41032 7.63679 5.77619 7.84586 6.14206C8.47306 7.22659 9.10026 8.29805 9.71439 9.38259C10.3155 10.4279 10.9165 11.4863 11.5176 12.5317C12.0533 13.4594 12.6021 14.4002 13.1379 15.3279C13.2424 15.5109 13.3469 15.6807 13.4515 15.8637C13.5429 15.9813 13.5168 16.0989 13.4123 16.2164Z" />
      <path
        d="M24.7542 4.41728C20.194 3.52874 19.0441 6.36421 19.0049 6.45568C18.6913 7.00448 18.3646 7.55328 18.038 8.11514C17.5937 8.87301 17.1625 9.63088 16.7182 10.4018C16.6268 10.5586 16.5484 10.7154 16.4438 10.8853C16.5222 11.0159 16.5876 11.1335 16.666 11.2511C16.9796 11.7869 17.2801 12.3095 17.5937 12.8453C17.9334 13.4333 18.2732 14.0343 18.5998 14.6223C18.6782 14.753 18.7697 14.7661 18.8612 14.6354C18.9265 14.5439 18.9526 14.4394 19.0049 14.3479C19.3577 13.7338 19.7236 13.1197 20.0764 12.5055C20.5729 11.6562 21.0564 10.7938 21.5529 9.94448C21.8012 9.51328 22.0494 9.08208 22.2977 8.66394L24.7542 4.41728Z"
        fill="#90C544" />
    </svg>
  </div>
</div>

@if (!isThemeActive() && isUserInfoPickerOpen) {
  <div
    class="user_info_customize_popup user_info_customize_popup--external"
    role="dialog"
    aria-label="Customize user info"
    [style.bottom.px]="userInfoPickerBottom"
    (click)="$event.stopPropagation()"
  >
    <div class="user_info_picker_bar">
      <button
        type="button"
        class="user_info_picker_btn"
        [class.user_info_picker_btn--active]="isBgSwatchOpen"
        matTooltip="Change background color"
        matTooltipAlways
        matTooltipPosition="right"
        aria-label="Change user info background color"
        [attr.aria-expanded]="isBgSwatchOpen"
        (click)="toggleBgSwatchPicker($event)"
      >
        <span
          class="user_info_picker_btn__icon user_info_picker_btn__icon--wheel"
          [style.background]="hasCustomUserInfoBg ? userInfoBgColor : '#25335b'"
          aria-hidden="true"
        ></span>
      </button>
      <button
        type="button"
        class="user_info_picker_btn user_info_picker_btn--banner"
        [class.user_info_picker_btn--active]="isBannerPickerOpen || hasCustomUserInfoBanner"
        matTooltip="Choose banner image"
        matTooltipAlways
        matTooltipPosition="right"
        aria-label="Choose banner image"
        [attr.aria-expanded]="isBannerPickerOpen"
        (click)="toggleBannerPicker($event)"
      >
        <span class="user_info_picker_btn__icon user_info_picker_btn__icon--banner" aria-hidden="true">
          <i class="fas fa-image"></i>
        </span>
      </button>
      <button
        type="button"
        class="user_info_picker_btn user_info_picker_btn--reset"
        matTooltip="Reset"
        matTooltipAlways
        matTooltipPosition="right"
        aria-label="Reset"
        [disabled]="!hasUserInfoCustomizations()"
        (click)="resetUserInfoColors()"
      >
        <span class="user_info_picker_btn__icon user_info_picker_btn__icon--reset" aria-hidden="true">
          <i class="fas fa-undo"></i>
        </span>
      </button>
    </div>

    @if (isBgSwatchOpen) {
      <div class="user_info_swatch_grid">
        @for (color of userInfoBgSwatches; track color) {
          <button
            type="button"
            class="user_info_swatch_option user_info_swatch_option--bg"
            [class.user_info_swatch_option--selected]="hasCustomUserInfoBg && userInfoBgColor.toLowerCase() === color"
            [style.--swatch-fill]="color"
            [attr.aria-label]="'Select background color ' + color"
            (click)="onUserInfoBgSwatchSelect(color, $event)"
          >
            <span class="user_info_swatch_fill"></span>
          </button>
        }
      </div>
    }

    @if (isBannerPickerOpen) {
      <div class="user_info_banner_grid">
        @for (banner of greetingBannerOptions; track banner) {
          <button
            type="button"
            class="user_info_banner_option"
            [class.user_info_banner_option--selected]="hasCustomUserInfoBanner && userInfoBannerImage === banner"
            [attr.aria-label]="'Select banner'"
            (click)="onUserInfoBannerSelect(banner, $event)"
          >
            <img [src]="banner" alt="" aria-hidden="true" />
          </button>
        }
      </div>
    }
  </div>
}

<!-- Radial Menu -->
<div
  class="radial_menu"
  [class.open]="isRadialMenuOpen"
  [class.radial_menu--picker-open]="!isThemeActive() && isUserInfoPickerOpen"
  [class.radial_menu--banner-open]="!isThemeActive() && isUserInfoPickerOpen && isUserInfoSwatchPanelOpen()"
  (click)="$event.stopPropagation()"
>
  <button class="quick_add radial_menu_btn" (click)="onAddClick()" [class.active]="isRadialMenuOpen">
    <img src="assets/images/quick.svg" alt="Add">
  </button>
  <!-- Radial Menu Items -->
  <div class="radial_menu_items">
    @for (item of radialMenuItems; track item.label; let i = $index) {
    <div class="radial_menu_item" [style.--item-index]="i"
      (click)="onRadialMenuItemClick(item, $event)">
      <div class="radial_item_content">
        <span class="radial_item_label">{{ item.label }}</span>
      </div>
    </div>
    }

  </div>
</div>